<script lang="ts" setup>
  import { InputWidthVariant } from '../../InputWrapper';
  import { useField } from 'vee-validate';
  import { computed, toRef } from 'vue';
  import type { MultiSelectProps, MultiSelectItem } from './MultiSelect.types';
  import MultiSelect from './MultiSelect.vue';

  export type MultiSelectFieldProps = Omit<MultiSelectProps, 'modelValue'> & {
    rules?: (value: MultiSelectItem[]) => string | boolean;
  };

  const props = withDefaults(defineProps<MultiSelectFieldProps>(), {
    rules: undefined,
    searchable: true,
    showLabels: false,
    showNoOptions: true,
    resettable: false,
    showNoResults: true,
    allowEmpty: false,
    taggable: false,
    disabled: false,
    meta: undefined,
    internalSearch: true,
    valueKey: 'value',
    labelKey: 'label',
    width: InputWidthVariant.FULL,
  });

  const inputName = toRef(props, 'name');
  const label = toRef(props, 'label');
  const rules = toRef(props, 'rules');

  const {
    value: inputValue,
    errorMessage,
    handleBlur,
    handleChange,
    meta,
  } = useField<MultiSelectItem[]>(inputName.value, rules?.value, {
    label: label?.value,
  });

  // Create computed props that include form field values
  const multiSelectProps = computed(() => ({
    ...props,
    error: errorMessage.value,
    modelValue: inputValue.value,
    meta,
  }));
</script>

<template>
  <MultiSelect
    v-bind="multiSelectProps"
    @blur="handleBlur"
    @update:model-value="handleChange"
  />
</template>
